import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./pages/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Resume from "./pages/Resume";
import NoPage from "./pages/NoPage";
import LocaleGate from "./pages/LocaleGate";
import { SiteCopyProvider } from "./context/SiteCopyContext";

function RootRedirect() {
  if (typeof navigator === "undefined" || !navigator.language) {
    return <Navigate to="/en" replace />;
  }
  const code = navigator.language.toLowerCase().split("-")[0];
  return <Navigate to={code === "nl" ? "/nl" : "/en"} replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<RootRedirect />} />
        <Route path="/:locale" element={<LocaleGate />}>
          <Route
            element={
              <SiteCopyProvider>
                <Layout />
              </SiteCopyProvider>
            }
          >
            <Route index element={<Home />} />
            <Route path="resume" element={<Resume />} />
            <Route path="about" element={<About />} />
            <Route path="contact" element={<Contact />} />
            <Route path="*" element={<NoPage />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
